import styled from 'styled-components';

import { Button, BUTTON_VARIANTS } from 'ui/button';
import { HyperLink } from 'ui/icons';
import { colors } from 'ui/theme';
import { useSmsSmartOptInContext } from 'modules/templateEditor/modals/SmsSmartOptInModal/contexts/SmsSmartOptInContext';
import { displayContent } from '../content';

const StyledButton = styled(Button)`
  white-space: nowrap;

  && path {
    stroke: ${colors.link};
  }
`;

export const TEMPLATE_EDITOR_SMS_SMART_OPT_IN_BUTTON = 'template-editor-sms-smart-opt-in-button';

export const SmsSmartOptInButton = () => {
  const { setIsModalOpen } = useSmsSmartOptInContext();

  return (
    <StyledButton
      data-test={TEMPLATE_EDITOR_SMS_SMART_OPT_IN_BUTTON}
      onClick={() => setIsModalOpen(true)}
      variant={BUTTON_VARIANTS.SECONDARY}
    >
      <HyperLink />
      <span>{displayContent.btnSmsSmartOptInOpenModal}</span>
    </StyledButton>
  );
};
